exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".half-width[data-v-7bd99cb6]{width:50%;margin:0 auto;min-width:700px;max-width:875px}.text--stack h3[data-v-7bd99cb6],.text--stack h5[data-v-7bd99cb6]{margin:0}.fg-addBuilding[data-v-7bd99cb6]{-webkit-box-align:end;-ms-flex-align:end;align-items:end}.addBuilding[data-v-7bd99cb6]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;padding:13px;border-radius:12%}.addBuilding i[data-v-7bd99cb6]{color:#30c193;position:relative;margin-top:10px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7bd99cb6","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/property/NewPropertyWizard.vue
// module id = D2Eq
// module chunks = 0 1